import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { styled } from '@mui/material/styles';
import { IconButton } from 'shared/mui/IconButtons';

export const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  height: '40px',
  width: '40px',
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const SmallRadioIcon = styled(RadioButtonUncheckedIcon)(({ theme }) => ({
  color: theme.palette.primary.light,
  fontSize: 8,
}));
